// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1yeOW","select":"Header_select__37hpw","clinic":"Header_clinic__hYKHz"};